export enum LoanOriginationSystemCreateTaskActionTypes {
  CreateTask = 'loanOriginationSystemCreateTask/createTask',
  CreateTaskSuccess = 'loanOriginationSystemCreateTask/createTaskSuccess',
  CreateTaskFailure = 'loanOriginationSystemCreateTask/createTaskFailure',
}
